import { render, staticRenderFns } from "./personOrderForm.vue?vue&type=template&id=1e28f678&scoped=true"
import script from "./personOrderForm.vue?vue&type=script&lang=js"
export * from "./personOrderForm.vue?vue&type=script&lang=js"
import style0 from "./personOrderForm.vue?vue&type=style&index=0&id=1e28f678&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e28f678",
  null
  
)

export default component.exports